import { MicroappActionTypes } from './action-types';
import { Microapp } from 'signup-constants/Microapp';
export const initialMicroappState = {
  [Microapp.EmailSignatureGenerator]: {
    emailSignature: '',
    contactVid: null,
    ownersExist: false
  },
  [Microapp.InvoiceGenerator]: {
    contactId: null,
    companyId: null,
    invoiceId: null,
    lineItemIds: []
  }
};
const microappReducer = (state = initialMicroappState, action) => {
  switch (action.type) {
    case MicroappActionTypes.UpdateMicroapp:
      return Object.assign({}, state, {
        [action.microapp]: Object.assign({}, state[action.microapp], action.data)
      });
    default:
      return state;
  }
};
export default microappReducer;